import {FlagInfoProps} from "@components/flags/info/FlagInfo.tsx";
import {TableCell, TableRow} from "@mui/material";
import {useEffect, useState} from "react";
import {IFlag} from "@models/shared/IFlag.ts";

interface FlagInfoRowProps extends Omit<FlagInfoProps, 'variant'> {
}

export function FlagInfoRow(props: FlagInfoRowProps) {
    const {value, EndComponent} = props
    const [v] = useState<IFlag | undefined>(value)

    useEffect(() => {
        //
    }, [value]);

    return (v && <TableRow>
        <TableCell>{v.id}</TableCell>
        <TableCell>{v.nome}</TableCell>
        <TableCell>{v.tipo}</TableCell>
        <TableCell>{EndComponent && v && <EndComponent {...v}/>}</TableCell>
    </TableRow>)
}